import type { RouteListItem } from '@/types';

export const settingsBcLink: RouteListItem = { path: '/settings', name: 'Settings' };
